import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ProjectWarehouseStock from "./ProjectWarehouseStock";
import Category from "./Category";
import InwardAndOutward from "./InwardAndOutward";
import ScrabApproval from "./ScrabApproval";
import ShortageMRBScrab from "./ShortageMRBScrab";
import Installation from "./Installation";
import Commissioning from "./Commissioning ";
import InstallationApproval from "./InstallationApproval";
import InstallationClaim from "./InstallationClaim";
import CommissioningClaim from "./CommissioningClaim";
import { getRecords } from "../../services/api.service";
import MRBApproval from "./MRBApproval";

const Dashboard = () => {
  const [breadcrumbItems] = useState([]);
  const [accesMenuData, setAccesMenuData] = useState([]);
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    fetchMenuData();
    fetchAccessMenuData();
  }, []);
  const fetchMenuData = async () => {
    try {
      const payload = {
        modelName: "menu_masters",
        whereCondition: { is_active: true },
        pagination: { page: 1, pageSize: 1000000 },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.code === 1) {
        responseData.data.forEach((element, index) => {
          element.index = index + 1;
        });
        setMenuData(responseData.data);
      }
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  };

  const fetchAccessMenuData = async () => {
    try {
      let authID = JSON.parse(localStorage.getItem("userDetails"));
      const payload = {
        modelName: "user_access",
        whereCondition: {
          user_id: authID.id,
          access: true,
          is_active: true,
        },
        pagination: { page: 1, pageSize: 1000000 },
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.code === 1) {
        setAccesMenuData(responseData.data);
      }
    } catch (error) {
      console.error("Error fetching access menu data:", error);
    }
  };
  const filterMenus = (menuData, accessMenuData) => {
    const allowedMenuIds = accessMenuData.map((item) => item.menu_id);
    return menuData.flat().filter((menu) => allowedMenuIds.includes(menu.id));
  };
  const filteredMenus = filterMenus(menuData, accesMenuData);
  return (
    <div className="page-content">
      <Container fluid>
        {/* <Breadcrumbs title="Dashboard" breadcrumbItems={breadcrumbItems} /> */}

        <Row>
          <Col xl={8}>
            <Row>
              <ProjectWarehouseStock />
            </Row>
            <InwardAndOutward />
          </Col>

          <Col xl={4}>
            <Category />

            {/* <ShortageMRBScrab /> */}
          </Col>
        </Row>

        <Row>
          <Col xl={6}>
            <Installation />
          </Col>
          <Col xl={6}>
            <Commissioning />
          </Col>
        </Row>

        <div className="overflow-auto">
          <div className="d-flex gap-3 min-w-max">
            {filteredMenus.some(
              (menu) => menu.menu_url === "/mrb-approval-list"
            ) && <MRBApproval />}
            {filteredMenus.some(
              (menu) => menu.menu_url === "/scrap-approval-list"
            ) && <ScrabApproval />}
            {filteredMenus.some(
              (menu) => menu.menu_url === "/installation-approval-list"
            ) && <InstallationApproval />}
            {filteredMenus.some(
              (menu) => menu.menu_url === "/installation-claim-list"
            ) && <InstallationClaim />}
            {filteredMenus.some(
              (menu) => menu.menu_url === "/commissioning-claim-list"
            ) && <CommissioningClaim />}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Dashboard;